{
  "schema-version": "1.0",
  "externalRepository": "npmjs.org",
  "org": "sap",
  "project": "ux-specification",
  "rootPpmsObjectId": "73555000100200012888",
  "rootPpmsObject": "FIORI ELEMENT SPEC 1.0",
  "distTags": [
    {
      "version": "1.144",
      "distTag": [
        "latest",
        "UI5-2.0",
        "UI5-2.1",
        "UI5-1.144",
        "UI5-1.145",
        "UI5-1.146",
        "UI5-1.147",
        "UI5-1.148",
        "UI5-1.149"
      ]
    },
    {
      "version": "1.142",
      "distTag": [
        "UI5-1.142",
        "UI5-1.143"
      ]
    },
    {
      "version": "1.139",
      "distTag": [
        "UI5-1.139",
        "UI5-1.140",
        "UI5-1.141"
      ]
    },
    {
      "version": "1.136",
      "distTag": [
        "UI5-1.136",
        "UI5-1.137",
        "UI5-1.138"
      ]
    },
    {
      "version": "1.124",
      "distTag": [
        "UI5-1.124",
        "UI5-1.125",
        "UI5-1.126",
        "UI5-1.127",
        "UI5-1.128",
        "UI5-1.129",
        "UI5-1.130",
        "UI5-1.131",
        "UI5-1.132",
        "UI5-1.133",
        "UI5-1.134",
        "UI5-1.135"
      ]
    },
    {
      "version": "1.120",
      "distTag": [
        "UI5-1.120",
        "UI5-1.121",
        "UI5-1.122",
        "UI5-1.123"
      ]
    },
    {
      "version": "1.108",
      "distTag": [
        "UI5-1.100",
        "UI5-1.101",
        "UI5-1.102",
        "UI5-1.103",
        "UI5-1.104",
        "UI5-1.105",
        "UI5-1.106",
        "UI5-1.107",
        "UI5-1.108",
        "UI5-1.109",
        "UI5-1.110",
        "UI5-1.111",
        "UI5-1.112",
        "UI5-1.113",
        "UI5-1.114",
        "UI5-1.115",
        "UI5-1.116",
        "UI5-1.117",
        "UI5-1.118",
        "UI5-1.119"
      ]
    },
    {
      "version": "1.96",
      "distTag": [
        "UI5-1.90",
        "UI5-1.91",
        "UI5-1.92",
        "UI5-1.93",
        "UI5-1.94",
        "UI5-1.95",
        "UI5-1.96",
        "UI5-1.97",
        "UI5-1.98",
        "UI5-1.99"
      ]
    },
    {
      "version": "1.84",
      "distTag": [
        "UI5-1.78",
        "UI5-1.79",
        "UI5-1.80",
        "UI5-1.81",
        "UI5-1.82",
        "UI5-1.83",
        "UI5-1.84",
        "UI5-1.85",
        "UI5-1.86",
        "UI5-1.87",
        "UI5-1.88",
        "UI5-1.89"
      ]
    },
    {
      "version": "1.71",
      "distTag": [
        "UI5-1.52",
        "UI5-1.53",
        "UI5-1.54",
        "UI5-1.55",
        "UI5-1.56",
        "UI5-1.57",
        "UI5-1.58",
        "UI5-1.59",
        "UI5-1.60",
        "UI5-1.61",
        "UI5-1.62",
        "UI5-1.63",
        "UI5-1.64",
        "UI5-1.65",
        "UI5-1.66",
        "UI5-1.67",
        "UI5-1.68",
        "UI5-1.69",
        "UI5-1.70",
        "UI5-1.71",
        "UI5-1.72",
        "UI5-1.73",
        "UI5-1.74",
        "UI5-1.75",
        "UI5-1.76",
        "UI5-1.77"
      ]
    }
  ]
}